var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.41007L6.71 1.17007C6.61704 1.07634 6.50644 1.00194 6.38458 0.951175C6.26272 0.900406 6.13201 0.874268 6 0.874268C5.86799 0.874268 5.73728 0.900406 5.61543 0.951175C5.49357 1.00194 5.38297 1.07634 5.29 1.17007L1.05 5.41007C0.956274 5.50303 0.881879 5.61363 0.83111 5.73549C0.780342 5.85735 0.754204 5.98805 0.754204 6.12007C0.754204 6.25208 0.780342 6.38278 0.83111 6.50464C0.881879 6.6265 0.956274 6.7371 1.05 6.83007C1.23736 7.01632 1.49082 7.12086 1.755 7.12086C2.01919 7.12086 2.27264 7.01632 2.46 6.83007L6 3.29007L9.54 6.83007C9.72626 7.01481 9.97766 7.11896 10.24 7.12007C10.3716 7.12083 10.5021 7.0956 10.6239 7.04584C10.7457 6.99607 10.8566 6.92275 10.95 6.83007C11.0471 6.74045 11.1254 6.63248 11.1805 6.51241C11.2356 6.39233 11.2664 6.26253 11.2711 6.13049C11.2757 5.99846 11.2541 5.86681 11.2076 5.74315C11.1611 5.6195 11.0905 5.50629 11 5.41007Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.c585fe700641f6b10231e09941c8d90f.svg";
export { ForwardRef as ReactComponent };